import CardPrice from "../../../CardPrices/CardPrice";
import useAppContext from "../../../../context/Context";

export const PlanPrivilege = ({ handleClick }) => {
  const { activeCountry } = useAppContext();

  const firstPlanCL = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
    { text: "Personaliza con tu marca", option: 1 },
    { text: "1 usuario de gestión", option: 1 },
  ];
  const firstPlanMX = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
    { text: "Payouts", option: 1 },
    { text: "Personaliza con tu marca", option: 1 },
    { text: "1 usuario de gestión", option: 1 },
  ];

  const secondPlanCL = [
    { text: "Débito directo(PAC)", sup: "1", option: 1 },

    { text: "Business Transfer", sup: "2", option: 1 },

    { text: "Personaliza con tu marca", option: 1 },
    { text: "2 usuarios de gestión", option: 1 },
    { text: "Soporte premium (chat)", option: 1 },
  ];
  const secondPlanCLTop = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
  ];

  const secondPlanMXTop = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
    { text: "Payouts", option: 1 },
  ];

  const thirdPlanCL = [
    { text: "Débito directo(PAC)", sup: "1", option: 1 },
    { text: "Business Transfer", sup: "2", option: 1 },
    { text: "Personaliza con tu marca", option: 1 },
    { text: "5 usuarios de gestión", option: 1 },
    { text: "Atención prioritaria SLA", option: 1 },
    { text: "Reporte mensual de incidencias", option: 1 },
  ];

  const thirdPlanCLTop = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
  ];

  const secondPlanMX = [
    { text: "Personaliza con tu marca", option: 1 },
    { text: "2 usuarios de gestión", option: 1 },
    { text: "Soporte premium (chat)", option: 1 },
  ];

  const thirdPlanMX = [
    { text: "Personaliza con tu marca", option: 1 },
    { text: "5 usuarios de gestión", option: 1 },
    { text: "Atención prioritaria SLA", option: 1 },
    { text: "Reporte mensual de incidencias", option: 1 },
  ];

  const thirdPlanMXTop = [
    { text: "Quick Transfer", option: 1 },
    { text: "Payment Links", option: 1 },
    { text: "Payouts", option: 1 },
  ];

  return (
    <>
      <div className="containerCardsPrices">
        <CardPrice
          titleTabPrices="Basic"
          descriptionTabPricesTop={
            activeCountry === "cl" ? "Paga por uso*" : "Paga por uso"
          }
          descriptionTabPricesTopSupEnd={activeCountry === "cl" ? "" : "1"}
          descriptionTabPrices={
            activeCountry === "cl"
              ? "*Facturación mínima $29.000 + IVA"
              : " Facturación mínima $540 + IVA"
          }
          descriptionTabPricesSup={activeCountry === "cl" ? "" : "1"}
          posSymbol="%"
          pricesTab={activeCountry === "cl" ? "1" : "1.8"}
          countryPrice={
            activeCountry === "cl"
              ? "por pago exitoso"
              : "+IVA por pago exitoso"
          }
          subtitlePricesTab="Para siempre"
          privilegeElection={
            "https://dashboard.etpay.com/sign-up?plan_selected=Basic"
          }
          handleClick={handleClick}
          vector={activeCountry === "cl" ? firstPlanCL : firstPlanMX}
          classCountry={
            activeCountry === "cl" ? "cardPricesCL" : "cardPricesMX"
          }
        />
        <CardPrice
          titleTabPrices="Starter"
          preSymbol="$"
          descriptionTabPricesSupEnd={activeCountry === "cl" ? "" : "2"}
          pricesTab={activeCountry === "cl" ? "69.900" : "1,790"}
          countryPrice={activeCountry === "cl" ? "+IVA al mes" : "+IVA al mes"}
          privilegeElection={
            "https://dashboard.etpay.com/sign-up?plan_selected=Starter"
          }
          vector={activeCountry === "cl" ? secondPlanCL : secondPlanMX}
          vectorTop={activeCountry === "cl" ? secondPlanCLTop : secondPlanMXTop}
          vectorTopName={
            activeCountry === "cl"
              ? "200 pagos exitosos al mes incluidos en:"
              : "150 pagos o 150.000MXN procesados² en:"
          }
          plus={[" Gestión de devoluciones"]}
          handleClick={handleClick}
          firstFree={true} // variable que indica que este es el plan más usado
          classCountry={
            activeCountry === "cl" ? "cardPricesCL" : "cardPricesMX"
          }
        />

        <CardPrice
          titleTabPrices="Plus"
          preSymbol="$"
          descriptionTabPricesSupEnd={activeCountry === "cl" ? "" : "2"}
          pricesTab={activeCountry === "cl" ? "129.900" : "3,990"}
          countryPrice={activeCountry === "cl" ? "+IVA al mes" : "+IVA al mes"}
          privilegeElection={
            "https://dashboard.etpay.com/sign-up?plan_selected=Plus"
          }
          handleClick={handleClick}
          vector={activeCountry === "cl" ? thirdPlanCL : thirdPlanMX}
          firstFree={true}
          vectorTop={activeCountry === "cl" ? thirdPlanCLTop : thirdPlanMXTop}
          vectorTopName={
            activeCountry === "cl"
              ? "400 pagos exitosos al mes incluidos en:"
              : "400 pagos o 500.000MXN procesados² en:"
          }
          // mostUsed={true}
          classCountry={
            activeCountry === "cl" ? "cardPricesCL" : "cardPricesMX"
          }
        />
      </div>
      <div className="sectionEnterprise">
        <div className="containerBoxEnterprise">
          <div className="text">
            <h2 className="textTitle">
              Enterprise
              {activeCountry === "mx" && <sup style={{ fontSize: 14 }}>3</sup>}
            </h2>
            <p className="textDescription">
              Diseñado a la medida de tu negocio. <br />
              Para grandes volúmenes de pago y transacciones de altos montos.
            </p>
            <p className="textGray">
              <sup style={{ fontSize: 10 }}>
                {activeCountry === "cl" ? "*" : "3"}{" "}
              </sup>
              Pensado para compañías de alto flujo (ej: servicios básicos,
              gambling, telco, etc).
            </p>
          </div>
          <div className="containerButton">
            <a
              className="textButton"
              href="https://dashboard.etpay.com/sign-up?plan_selected=Enterprise"
            >
              Contacta con ventas
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
